/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceTypeEnum } from './resourceTypeEnum';


/**
 * Carbon Black Config
 */
export interface IrrCarbonBlackConfig { 
    enabled: boolean;
    /**
     * API client location
     */
    apiClientLocation?: string;
    /**
     * API client timestamp
     */
    apiClientTimestamp?: string;
    /**
     * API endpoint
     */
    apiEndpoint?: string;
    /**
     * Org Id
     */
    orgId?: number;
    /**
     * Org Key
     */
    orgKey?: string;
    mode?: ResourceTypeEnum;
}
export namespace IrrCarbonBlackConfig {
}


